/**
 * Feature flags explicitly used by Payment SDK.
 */
export enum FeatureFlagList {
  AllowCobadgedCards = 'feature.payment-processing.allow-cobadged-cards',
  PayByLinkFrontErrorLogging = 'feature.payment-processing.pay-by-link-front-error-logging',
}
